'use client';

import { PageProps } from '@/lib/types';
import { Breadcrumb, Section } from '@/ui';
import { Content } from '@/widgets';
import { Container } from '@mantine/core';

type Props = {
  data: PageProps & { corruption_title: string };
  children: React.ReactNode;
};

export default function AntiCorruption({ data, children }: Props) {
  const breadcrumbItems = [
    { title: data?.breadcrumb, href: `/general-menu/${data?.menu_id}` },
    { title: data?.corruption_title, isCurrent: true },
  ];

  return (
    <Container>
      <Section rightMenu={{ isActive: true, id: data?.menu_id, activeItem: { id: data?.menu_item_id } }}>
        <Content>
          <Content.Header>
            <Breadcrumb items={breadcrumbItems} />
          </Content.Header>
          <Content.Title>{data?.corruption_title}</Content.Title>
          <Content.Body>{children}</Content.Body>
        </Content>
      </Section>
    </Container>
  );
}
